const REAUTH_ATTEMPTED_KEY = "tendra.reauth_attempted";

/**
 * A 401 means the access token expired, and signing in again is a full-page
 * redirect. Exactly one redirect is allowed per session: if the request still
 * comes back 401 afterwards, redirecting again would loop the browser through
 * the authorize endpoint forever.
 *
 * This is deliberately separate from the silent-renew flag, which login()
 * clears on every call and so cannot hold a loop open.
 */
export function claimReauthAttempt(): boolean {
  try {
    if (sessionStorage.getItem(REAUTH_ATTEMPTED_KEY) === "1") {
      return false;
    }

    sessionStorage.setItem(REAUTH_ATTEMPTED_KEY, "1");

    return true;
  } catch {
    // Private windows and blocked site data: never redirect rather than loop.
    return false;
  }
}

/** Called when a request succeeds, proving the current token works. */
export function clearReauthAttempt(): void {
  try {
    sessionStorage.removeItem(REAUTH_ATTEMPTED_KEY);
  } catch {
    // Nothing to clear when storage is unavailable.
  }
}
